import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import AnimatedCup from 'components/common/AnimatedCup';

const LoadingPage = () => (
  <div className="loan-form__step loan-form__step--space-top-bottom">
    <div className="loan-form__step-body txt-center">
      <AnimatedCup />
      <FormattedMessage id="loading.title" tagName="h2" />
      <FormattedMessage id="loading.text" tagName="p" />
    </div>
  </div>
);

LoadingPage.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types -- node upgrade
  size: PropTypes.string,
};

export default LoadingPage;
